<template>
  <div class="logged-home">
    <WelcomeFirstAccessModal
      :open="showWelcomeModal"
      :username="username"
      @close="closeWelcomeModal"
      @go-profile="goProfileFromWelcome"
      @go-courses="goCoursesFromWelcome"
    />
    <link
      rel="stylesheet"
      href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/5.15.4/css/all.min.css"
    />
    <section class="home-content" ref="homeSection">
      <div class="text-section">
        <h1>
          Seja bem-vindo, <span class="name">{{ username }}!</span>
        </h1>
        <h3 class="text-animation">Conecte e <span></span></h3>
        <p class="home-tagline">
          Enquanto o mercado vende emoção, a <span class="brand-highlight">ZIMA</span> te entrega estrutura.
          <br />
          Conecte, aprenda e automatize.
        </p>

        <div class="btn-group">
          <button type="button" class="btn tutorial" @click="handlePrimaryAction">{{ primaryActionLabel }}</button>
          <button type="button" class="btn wallet" @click="handleSecondaryAction">{{ secondaryActionLabel }}</button>
        </div>

        
      </div>

      <!-- Remover a imagem em telas menores -->
      <div class="home-img">
        <DotLottieVue
          class="hero-lottie"
          autoplay
          loop
          src="https://lottie.host/804631f8-59f1-4645-ab1e-5e6ad01b8af6/YWiC52u1cN.lottie"
        />
      </div>
    </section>

    <section class="community-section" aria-labelledby="community-title">
      <div class="community-head">
        <span class="community-kicker"><span class="community-kicker__text">COMUNIDADE ZIMA</span></span>
        <h2 id="community-title" class="community-title">
          O mercado grita o tempo todo
          <span class="community-title-accent">Aqui a gente filtra o que importa</span>
        </h2>
        <p class="community-text">
          Entre no Discord da <span class="brand-highlight">ZIMA</span> para acompanhar o que tá mexendo de verdade no mercado
          <span class="community-aside">— só leitura real, no ritmo de quem opera.</span>
        </p>
        <div class="community-actions">
          <button type="button" class="stats-btn telegram" @click="openDiscordCommunity">
            ENTRAR NA COMUNIDADE
          </button>
        </div>
      </div>

      <div class="community-grid" aria-label="Destaques da comunidade">
        <article class="community-card signal">
          <div class="community-card__meta">Pulso</div>
          <div class="community-card__title">Radar ao vivo</div>
          <p class="community-card__text">O que tá mexendo no mercado, na hora que mexe <span class="community-aside">— leitura prática, zero ruído.</span></p>
        </article>

        <article class="community-card voice">
          <div class="community-card__meta">Ambiente</div>
          <div class="community-card__title">Acompanhamento ativo</div>
          <p class="community-card__text">O lugar pra entender o contexto antes de agir <span class="community-aside">— e não depois que já era.</span></p>
        </article>

        <article class="community-card discord">
          <div class="community-card__meta">Entrada</div>
          <div class="community-card__title">Base da comunidade</div>
          <p class="community-card__text">Acompanhe o pulso da comunidade e receba atualizações rápidas.</p>
        </article>
      </div>
    </section>

    <section class="stats-section" id="stats" ref="statsSection">
      <div class="stats-hero">
        <h2 class="stats-title">
          <span class="stats-title-accent">INFORMAÇÃO CERTA</span>
          <span class="stats-title-plain">EXECUÇÃO SILENCIOSA</span>
        </h2>
        <p class="stats-subtitle">
          <span class="stats-subtitle-line">Opere no ritmo das <span class="brand-highlight">whales</span>.</span>
          <span class="stats-subtitle-line">Sem ruídos, apenas resultados.</span>
        </p>
      </div>
        <div class="btn-container">
          <button type="button" class="stats-btn telegram" @click="goDashboard">DASHBOARD</button>
          <button type="button" class="stats-btn platform" @click="openDiscordCommunity">GRUPO DISCORD</button>
        </div>
      <div class="stats-grid">
        <div class="stat-card members">
          <div class="stat-value value-members">{{ formatMembers(homeStats.members) }}</div>
          <div class="stat-label">MEMBROS</div>
        </div>
        <div class="stat-card support">
          <div class="stat-value value-support">24/7</div>
          <div class="stat-label">SUPORTE</div>
        </div>
      </div>
      <Footer />
    </section>
  </div>
</template>



<script>
import { DotLottieVue } from '@lottiefiles/dotlottie-vue';
import Footer from './Footer.vue';
import WelcomeFirstAccessModal from './WelcomeFirstAccessModal.vue';
import { API_BASE_URL } from '@/config/env';

const WELCOME_SESSION_KEY = 'zima_show_welcome_once';
const DISCORD_INVITE_URL = 'https://discord.gg/GV7d8MATYG';

export default {
  name: 'LoggedHome',
  components: {
    DotLottieVue,
    Footer,
    WelcomeFirstAccessModal,
  },
  data() {
    return {
      homeStats: {
        members: 0,
        winRate: 0,
        signalsEmitted: 0,
      },
      statsRefreshTimer: null,
      showWelcomeModal: false,
    };
  },
  computed: {
    username() {
      return this.$store.getters.username;
    },
    walletConnected() {
      return this.$store.getters.walletConnected;
    },
    primaryActionLabel() {
      return this.walletConnected ? 'Trades' : 'Conectar';
    },
    secondaryActionLabel() {
      return this.walletConnected ? 'Análises' : 'Tutoriais';
    },
  },
  async mounted() {
    this.$store.dispatch('hydrateFromStorage');
    window.addEventListener('profile-username-updated', this.syncUsername);
    window.addEventListener('storage', this.handleStorage);
    window.addEventListener('keydown', this.handleKeydown);
    this.evaluateWelcomeModal();
    await this.fetchHomeStats();
    this.statsRefreshTimer = window.setInterval(() => {
      this.fetchHomeStats();
    }, 60 * 1000);
  },
  beforeUnmount() {
    window.removeEventListener('profile-username-updated', this.syncUsername);
    window.removeEventListener('storage', this.handleStorage);
    window.removeEventListener('keydown', this.handleKeydown);
    if (this.statsRefreshTimer) {
      window.clearInterval(this.statsRefreshTimer);
      this.statsRefreshTimer = null;
    }
  },
  methods: {
    syncUsername(e) {
      const newName = e && e.detail ? e.detail : '';
      this.$store.dispatch('setUsername', newName);
    },
    handleStorage(e) {
      if (e.key === 'username' || e.key === 'user_profile') {
        this.$store.dispatch('hydrateFromStorage');
        this.evaluateWelcomeModal();
      }
    },
    handleKeydown(event) {
      if (event.key === 'Escape' && this.showWelcomeModal) {
        this.closeWelcomeModal();
      }
    },
    evaluateWelcomeModal() {
      if (typeof sessionStorage === 'undefined') return;
      const shouldTryOpen = sessionStorage.getItem(WELCOME_SESSION_KEY) === '1';
      if (!shouldTryOpen) return;
      this.showWelcomeModal = true;
    },
    closeWelcomeModal() {
      if (typeof sessionStorage !== 'undefined') {
        sessionStorage.removeItem(WELCOME_SESSION_KEY);
      }
      this.showWelcomeModal = false;
    },
    goProfileFromWelcome() {
      this.closeWelcomeModal();
      this.goProfile();
    },
    goCoursesFromWelcome() {
      this.closeWelcomeModal();
      this.goCourses();
    },
    goProfile() {
      this.$router.push({ name: 'Profile', query: { openWallet: '1' } });
    },
    goCourses() {
      this.$router.push({ name: 'Courses', query: { openModule: '1' } });
    },
    goDashboard() {
      this.$router.push('/dashboard');
    },
    goTrades() {
      this.$router.push('/trades');
    },
    goAnalysis() {
      this.$router.push('/analysis');
    },
    handlePrimaryAction() {
      if (this.walletConnected) {
        this.goTrades();
        return;
      }
      this.goProfile();
    },
    handleSecondaryAction() {
      if (this.walletConnected) {
        this.goAnalysis();
        return;
      }
      this.goCourses();
    },
    async fetchHomeStats() {
      await this.fetchMembersCount();

      const urls = this.buildApiCandidates('/api/v1/public/home-stats');
      for (const url of urls) {
        try {
          const response = await fetch(url, { cache: 'no-store' });
          if (!response.ok) {
            continue;
          }
          const payload = await response.json();
          this.homeStats = {
            members: this.homeStats.members,
            winRate: Number(payload?.win_rate ?? payload?.winRate) || 0,
            signalsEmitted: Number(payload?.signals_emitted ?? payload?.signalsEmitted) || 0,
          };
          return;
        } catch (_) {
          // try next URL candidate
        }
      }
      console.error('Erro ao carregar stats da home: nenhuma URL respondeu', urls);
    },
    async fetchMembersCount() {
      const urls = this.buildApiCandidates('/api/v1/public/members-count');
      for (const url of urls) {
        try {
          const response = await fetch(url, { cache: 'no-store' });
          if (!response.ok) continue;
          const payload = await response.json();
          const members = Number(payload?.members_count ?? payload?.members);
          if (Number.isFinite(members) && members >= 0) {
            this.homeStats.members = members;
            return;
          }
        } catch (_) {
          // try next URL candidate
        }
      }
    },
    formatMembers(value) {
      return new Intl.NumberFormat('pt-BR').format(Number(value) || 0);
    },
    formatWinRate(value) {
      const numeric = Number(value);
      if (!Number.isFinite(numeric)) return '0%';
      return `${numeric.toFixed(1)}%`;
    },
    formatSignals(value) {
      return new Intl.NumberFormat('pt-BR').format(Number(value) || 0);
    },
    buildApiCandidates(path) {
      const normalizedBase = String(API_BASE_URL || '').replace(/\/+$/, '');
      const normalizedPath = String(path).startsWith('/') ? String(path) : `/${path}`;

      const candidates = [];
      if (normalizedBase) {
        candidates.push(`${normalizedBase}${normalizedPath}`);
      }

      // Prefer direct API host in local dev to avoid noisy 404s on :8080.
      candidates.push(`http://localhost:8765${normalizedPath}`);
      candidates.push(`http://127.0.0.1:8765${normalizedPath}`);
      candidates.push(normalizedPath);

      return [...new Set(candidates)];
    },
    openDiscordCommunity() {
      window.open(DISCORD_INVITE_URL, '_blank', 'noopener,noreferrer');
    },
  },
};
</script>

<style scoped>
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

body * {
  box-sizing: border-box;
}

.logged-home {
  display: flex;
  flex-direction: column;
  align-items: center;
  min-height: 100vh;
  background-color: #181a20;
}

.home-content {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: min(100%, var(--app-max-width));
  padding: calc(var(--app-header-h) - 14px) var(--app-gutter) 20px;
  gap: 24px;
  margin-top: -22px;
}

.text-section {
  flex: 1;
  color: #fff;
  margin-top: -10px;
}

h1,
h3 {
  font-size: 3rem;
  margin: 0.5rem 0;
}

h1 span.name {
  color: #94d2bd;
  /* Glowing text color */
}

h3 span {
  position: relative;
  color: #f72585;
}

/* keep global p defaults for others but override specific tagline */
p {
  font-size: 1.1rem;
  margin: 1.5rem 0;
  line-height: 1.6;
}

.home-tagline {
  font-size: 1.2rem;
  line-height: 1.6;
  max-width: 640px;
  color: #dfe5ff;
  letter-spacing: 0.02em;
  font-family: 'Space Grotesk', 'Manrope', 'Inter', sans-serif;
}

.brand-highlight {
  background: linear-gradient(135deg, #4e73df 0%, #9b59b6 100%);
  background-clip: text;
  -webkit-background-clip: text;
  color: transparent;
  font-weight: 800;
  text-shadow: 0 2px 12px rgba(78, 115, 223, 0.35);
}

.btn-group {
  margin-top: 20px;
}

.btn {
  padding: 10px 30px;
  border-radius: 50px;
  font-weight: bold;
  text-transform: uppercase;
  transition: background-color 0.3s ease, transform 0.3s ease;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  line-height: 1;
  min-height: 40px;
  margin-right: 15px;
  -webkit-user-drag: none;
  user-select: none;
  cursor: pointer;
  background: transparent;
  border: none;
  font-family: inherit;
  font-size: 0.95rem;
}

.btn.wallet {
  background-color: transparent;
  color: white;
  text-decoration: none;
  border: 2px solid #4e73df;
}

.btn.tutorial {
  color: #fff;
  background: linear-gradient(135deg, #5f27cd 0%, #3498db 100%);
  text-decoration: none;
}

.btn:hover {
  transform: translateY(-3px);
  text-decoration: none;
}

.btn.wallet:hover {
  background-color: #4e73df;
  color: #fff;
  text-decoration: none;
}

.btn.tutorial:hover {
  background: linear-gradient(135deg, #4e73df 0%, #9b59b6 100%);
  transform: translateY(-3px);
  /* Subtle hover lift effect */
  text-decoration: none;
}

.home-img {
  flex: 1;
  display: flex;
  justify-content: center;
}

.hero-lottie {
  width: clamp(320px, 48vw, 630px);
  height: clamp(320px, 48vw, 630px);
}

.community-section {
  width: min(100%, var(--app-max-width));
  padding: 10px var(--app-gutter) 12px;
}

.community-head {
  max-width: 1120px;
  margin: 0 auto 28px;
  text-align: center;
}

.community-kicker {
  position: relative;
  display: inline-grid;
  place-items: center;
  margin-bottom: 18px;
  padding: 0 22px;
  min-height: 44px;
  font-size: 0.88rem;
  font-weight: 800;
  letter-spacing: 0.28em;
  text-transform: uppercase;
  background:
    linear-gradient(135deg, rgba(14, 19, 36, 0.96) 0%, rgba(18, 24, 44, 0.92) 48%, rgba(14, 19, 36, 0.96) 100%);
  clip-path: polygon(14px 0, calc(100% - 14px) 0, 100% 50%, calc(100% - 14px) 100%, 14px 100%, 0 50%);
  box-shadow:
    inset 0 0 0 1px rgba(116, 138, 255, 0.22),
    0 10px 24px rgba(0, 0, 0, 0.24);
  isolation: isolate;
  overflow: hidden;
}

.community-kicker::before {
  content: '';
  position: absolute;
  inset: 8px 10px;
  clip-path: polygon(12px 0, calc(100% - 12px) 0, 100% 50%, calc(100% - 12px) 100%, 12px 100%, 0 50%);
  background:
    radial-gradient(circle at 16% 50%, rgba(98, 168, 255, 0.18) 0%, rgba(98, 168, 255, 0) 36%),
    radial-gradient(circle at 84% 50%, rgba(171, 115, 255, 0.18) 0%, rgba(171, 115, 255, 0) 34%),
    linear-gradient(90deg, rgba(111, 145, 255, 0.12) 0%, rgba(78, 115, 223, 0.08) 45%, rgba(155, 89, 182, 0.12) 100%);
  filter: blur(10px);
  z-index: -2;
}

.community-kicker::after {
  content: '';
  position: absolute;
  inset: 0;
  clip-path: polygon(14px 0, calc(100% - 14px) 0, 100% 50%, calc(100% - 14px) 100%, 14px 100%, 0 50%);
  background:
    linear-gradient(90deg, rgba(111, 145, 255, 0.88) 0 22px, transparent 22px calc(100% - 22px), rgba(167, 139, 250, 0.88) calc(100% - 22px) 100%);
  opacity: 0.95;
  z-index: -1;
  mask:
    linear-gradient(#000 0 0) content-box,
    linear-gradient(#000 0 0);
  -webkit-mask:
    linear-gradient(#000 0 0) content-box,
    linear-gradient(#000 0 0);
  padding: 1px;
  mask-composite: exclude;
  -webkit-mask-composite: xor;
}

.community-kicker__text::before {
  content: '';
  position: absolute;
  inset: -10px auto -10px -42px;
  width: 28px;
  background: linear-gradient(180deg, rgba(125, 176, 255, 0) 0%, rgba(125, 176, 255, 0.88) 50%, rgba(176, 140, 255, 0) 100%);
  opacity: 0.65;
  filter: blur(8px);
  transform: skewX(-20deg);
  animation: community-kicker-scan 4.8s ease-in-out infinite;
  pointer-events: none;
}

.community-kicker__text {
  position: relative;
  z-index: 1;
  display: inline-block;
  background: linear-gradient(90deg, #e8f2ff 0%, #f6f9ff 24%, #88bcff 58%, #b18dff 100%);
  background-size: 180% 100%;
  background-position: 50% 50%;
  -webkit-background-clip: text;
  background-clip: text;
  color: transparent;
  -webkit-text-fill-color: transparent;
  text-shadow:
    0 0 10px rgba(127, 176, 255, 0.2),
    0 0 22px rgba(176, 140, 255, 0.16);
  animation: community-kicker-glow 7s ease-in-out infinite, community-kicker-shift 6.5s ease-in-out infinite alternate;
}

@keyframes community-kicker-glow {
  0%,
  100% {
    text-shadow:
      0 0 10px rgba(127, 176, 255, 0.22),
      0 0 18px rgba(176, 140, 255, 0.16);
    filter: brightness(1);
  }
  50% {
    text-shadow:
      0 0 14px rgba(125, 176, 255, 0.24),
      0 0 24px rgba(127, 176, 255, 0.22),
      0 0 32px rgba(176, 140, 255, 0.2);
    filter: brightness(1.08);
  }
}

@keyframes community-kicker-shift {
  0% {
    background-position: 18% 50%;
  }
  100% {
    background-position: 82% 50%;
  }
}

@keyframes community-kicker-scan {
  0%,
  14% {
    transform: translateX(0) skewX(-20deg);
    opacity: 0;
  }
  22% {
    opacity: 0.7;
  }
  52% {
    transform: translateX(240px) skewX(-20deg);
    opacity: 0.7;
  }
  68%,
  100% {
    transform: translateX(280px) skewX(-20deg);
    opacity: 0;
  }
}

.community-title {
  margin: 0;
  color: #ffffff;
  line-height: 1.12;
  font-weight: 900;
  letter-spacing: 0.3px;
  font-size: clamp(28px, 4.4vw, 62px);
}

.community-title-accent {
  display: block;
  background: linear-gradient(120deg, #4e73df 0%, #9b59b6 60%, #7f7bff 100%);
  -webkit-background-clip: text;
  background-clip: text;
  color: transparent;
  text-shadow: 0 3px 12px rgba(78, 115, 223, 0.38);
  padding-bottom: 0.08em;
}

.community-text {
  max-width: 720px;
  margin: 14px auto 0;
  color: #a9b0be;
  font-size: clamp(14px, 2.1vw, 18px);
  line-height: 1.7;
  font-family: 'Space Grotesk', 'Manrope', 'Inter', sans-serif;
}

.community-aside {
  font-style: italic;
}

.community-actions {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 16px;
  margin-top: 24px;
}

.community-grid {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 22px;
  max-width: 1100px;
  margin: 0 auto;
}

.community-card {
  display: grid;
  gap: 10px;
  min-height: 190px;
  padding: 28px 26px;
  border-radius: 16px;
  background: transparent;
  color: #fff;
  transition: transform 0.25s ease, box-shadow 0.25s ease;
  font-family: 'Space Grotesk', 'Manrope', 'Inter', sans-serif;
}

.community-card:hover {
  transform: translateY(-4px);
}

.community-card.signal {
  box-shadow: inset 0 0 0 1px rgba(148, 210, 189, 0.35);
}

.community-card.voice {
  box-shadow: inset 0 0 0 1px rgba(78, 115, 223, 0.35);
}

.community-card.discord {
  box-shadow: inset 0 0 0 1px rgba(167, 139, 250, 0.35);
}

.community-card.signal:hover {
  box-shadow: inset 0 0 0 1px rgba(148, 210, 189, 0.6), 0 0 0 2px rgba(148, 210, 189, 0.18), 0 10px 24px rgba(0, 0, 0, 0.42);
}

.community-card.voice:hover {
  box-shadow: inset 0 0 0 1px rgba(78, 115, 223, 0.6), 0 0 0 2px rgba(78, 115, 223, 0.18), 0 10px 24px rgba(0, 0, 0, 0.42);
}

.community-card.discord:hover {
  box-shadow: inset 0 0 0 1px rgba(167, 139, 250, 0.6), 0 0 0 2px rgba(167, 139, 250, 0.18), 0 10px 24px rgba(0, 0, 0, 0.42);
}

.community-card__meta {
  font-size: 0.78rem;
  font-weight: 800;
  letter-spacing: 0.22em;
  text-transform: uppercase;
  opacity: 0.88;
}

.community-card.signal .community-card__meta {
  color: #94d2bd;
}

.community-card.voice .community-card__meta {
  color: #79a7ff;
}

.community-card.discord .community-card__meta {
  color: #a78bfa;
}

.community-card__title {
  font-size: clamp(18px, 1.65vw, 23px);
  line-height: 1.12;
  font-weight: 800;
}

.community-card__text {
  margin: 0;
  color: #c8cdd8;
  font-size: 0.95rem;
  line-height: 1.65;
}

.stats-section {
  width: 100%;
  padding: 60px 20px 8px;
  background: linear-gradient(180deg, #181a20 0%, #0f1015 100%);
}

.stats-hero {
  max-width: 1000px;
  margin: 0 auto 28px;
  text-align: center;
}

.stats-title {
  margin: 0 0 12px;
  line-height: 1.1;
  font-weight: 900;
  letter-spacing: 0.5px;
  font-size: clamp(28px, 5.5vw, 68px);
}

.stats-title-accent {
  display: block;
  position: relative;
  background: linear-gradient(120deg, #4e73df 0%, #9b59b6 60%, #7f7bff 100%);
  -webkit-background-clip: text;
  background-clip: text;
  color: transparent;
  text-shadow: 0 3px 12px rgba(78, 115, 223, 0.45), 0 0 18px rgba(155, 89, 182, 0.25);
}

.stats-title-accent::before {
  content: '';
  position: absolute;
  top: 15%;
  left: 6%;
  right: 6%;
  height: 70%;
  background-image:
    radial-gradient(circle, rgba(78, 115, 223, 0.35) 0, rgba(78, 115, 223, 0.35) 1px, transparent 2px),
    radial-gradient(circle, rgba(155, 89, 182, 0.3) 0, rgba(155, 89, 182, 0.3) 1px, transparent 2px),
    radial-gradient(circle, rgba(127, 123, 255, 0.3) 0, rgba(127, 123, 255, 0.3) 1px, transparent 2px);
  background-size: 36px 24px, 42px 28px, 28px 20px;
  background-position: 0 0, 20px 8px, 10px 16px;
  opacity: 0.35;
  filter: blur(0.2px);
  z-index: -1;
  pointer-events: none;
}

.stats-title-plain {
  display: block;
  color: #ffffff;
  text-shadow: 0 4px 24px rgba(0, 0, 0, 0.45);
}

.stats-subtitle {
  color: #a9b0be;
  font-size: clamp(14px, 2.2vw, 18px);
  margin: 8px 0 22px;
  font-family: 'Space Grotesk', 'Manrope', 'Inter', sans-serif;
  letter-spacing: 0.02em;
}

.stats-subtitle-line {
  display: block;
}

.btn-container {
  display: flex;
  justify-content: center;
  gap: 20px;
  margin-bottom: 40px;
}

.stats-btn {
  padding: 12px 30px;
  border-radius: 30px;
  font-weight: bold;
  text-transform: uppercase;
  color: #fff;
  border: 2px solid #4e73df;
  text-decoration: none;
  transition: background 0.3s ease, transform 0.3s ease;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  line-height: 1;
  min-height: 44px;
  -webkit-user-drag: none;
  user-select: none;
  cursor: pointer;
  font-size: 0.95rem;
}

.stats-btn.platform {
  background: transparent;
}

.stats-btn.telegram {
  background: linear-gradient(135deg, #5f27cd 0%, #3498db 100%);
  border: none;
}

.stats-btn:hover {
  transform: translateY(-3px);
  text-decoration: none;
  
}

.stats-btn.platform:hover {
  background: #4e73df;
}

.stats-btn.telegram:hover {
  background: linear-gradient(135deg, #4e73df 0%, #9b59b6 100%);
}

.stats-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(240px, 1fr));
  gap: 22px;
  max-width: 1100px;
  margin: 0 auto;
}

.stat-card {
  position: relative;
  background: transparent;
  padding: 26px 30px;
  border-radius: 16px;
  border: none;
  min-height: 130px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  gap: 6px;
  color: #fff;
  transition: transform 0.25s ease, background 0.25s ease, box-shadow 0.25s ease;
  font-family: 'Space Grotesk', 'Manrope', 'Inter', sans-serif;
}

.stat-card:hover {
  transform: translateY(-4px);
  background: transparent;
}

/* Base inner border per card using inset shadow */
.stat-card.members { box-shadow: inset 0 0 0 1px rgba(148, 210, 189, 0.35); }
.stat-card.winrate { box-shadow: inset 0 0 0 1px rgba(78, 115, 223, 0.35); }
.stat-card.signals { box-shadow: inset 0 0 0 1px rgba(255, 209, 102, 0.35); }
.stat-card.support { box-shadow: inset 0 0 0 1px rgba(167, 139, 250, 0.35); }

/* Color-accented hover per card */
.stat-card.members:hover { box-shadow: inset 0 0 0 1px rgba(148, 210, 189, 0.6), 0 0 0 2px rgba(148, 210, 189, 0.22), 0 10px 24px rgba(0, 0, 0, 0.45); }
.stat-card.winrate:hover { box-shadow: inset 0 0 0 1px rgba(78, 115, 223, 0.6), 0 0 0 2px rgba(78, 115, 223, 0.22), 0 10px 24px rgba(0, 0, 0, 0.45); }
.stat-card.signals:hover { box-shadow: inset 0 0 0 1px rgba(255, 209, 102, 0.6), 0 0 0 2px rgba(255, 209, 102, 0.22), 0 10px 24px rgba(0, 0, 0, 0.45); }
.stat-card.support:hover { box-shadow: inset 0 0 0 1px rgba(167, 139, 250, 0.6), 0 0 0 2px rgba(167, 139, 250, 0.22), 0 10px 24px rgba(0, 0, 0, 0.45); }

.stat-value { font-size: clamp(28px, 4.6vw, 36px); line-height: 1; font-weight: 800; }
.stat-label { margin-top: 8px; font-size: 0.85rem; letter-spacing: 1px; color: #c8cdd8; opacity: 0.9; }

/* Metric number colors */
.value-members { color: #94d2bd; }
.value-winrate { color: #4e73df; }
.value-signals { color: #ffd166; }
.value-support { color: #a78bfa; }



.text-animation {
  font-size: 34px;
  font-weight: 600;
  min-width: 280px;
}

.text-animation span {
  position: relative;
}

.text-animation span::before {
  content: 'Automatize';
  color: #7394f0;
  animation: words 20s infinite;
}

.text-animation span::after {
  content: '';
  background-color: #181a20;
  position: absolute;
  width: calc(100% + 8px);
  height: 100%;
  border-left: 3px solid #181a20;
  right: -8px;
  animation: cursor 0.6s infinite, typing 20s steps(14) infinite;
}

@keyframes cursor {
  to {
    border-left: 2px solid #7394f0;
  }
}

@keyframes words {
  0%,
  20% {
    content: 'AUTOMATIZE';
  }
  21%,
  40% {
    content: 'ESTRUTURE';
  }
  41%,
  60% {
    content: 'CONQUISTE';
  }
  61%,
  80% {
    content: 'VISUALIZE';
  }
  81%,
  100% {
    content: 'LIBERTE-SE';
  }
}

@keyframes typing {
  10%,
  15%,
  30%,
  35%,
  50%,
  55%,
  70%,
  75%,
  90%,
  95% {
    width: 0;
  }
  5%,
  20%,
  25%,
  40%,
  45%,
  60%,
  65%,
  80%,
  85% {
    width: calc(100% + 8px);
  }
}

@keyframes accent-glow {
  0%,
  100% {
    text-shadow: 0 0 10px rgba(0, 229, 255, 0.3), 0 0 24px rgba(0, 229, 255, 0.18);
  }
  50% {
    text-shadow: 0 0 16px rgba(0, 229, 255, 0.55), 0 0 36px rgba(0, 229, 255, 0.32);
  }
}

@keyframes accent-shift {
  0%,
  100% {
    background-position: 0% 50%;
  }
  50% {
    background-position: 100% 50%;
  }
}

@keyframes accent-particles {
  0% {
    transform: translateX(0);
  }
  50% {
    transform: translateX(12px);
  }
  100% {
    transform: translateX(0);
  }
}

/* Responsive styles */
@media (max-width: 1199px) {
  h1,
  h3 {
    font-size: 2.6rem;
  }

  .community-grid {
    grid-template-columns: 1fr;
  }
}

@media (max-width: 767px) {
  .logged-home {
    flex-direction: column;
    justify-content: flex-start;
    padding: 10px 0 0;
  }

  .home-content {
    flex-direction: column;
    width: 100%;
    text-align: center;
    padding-top: calc(var(--app-header-h) + 2px);
    align-items: center;
    margin-top: 0;
  }

  .community-section {
    padding: 4px var(--app-gutter) 12px;
  }

  .community-title {
    font-size: clamp(1.7rem, 9vw, 2.5rem);
  }

  .community-actions {
    flex-direction: column;
  }

  .community-actions .stats-btn {
    width: 100%;
  }

  .community-card {
    min-height: unset;
    padding: 24px 22px;
  }

  .text-section {
    margin-top: 0;
    padding: 0 8px;
  }

  .home-img {
    display: none;
  }

  .btn {
    padding: 8px 20px;
  }

  .btn-group {
    display: flex;
    justify-content: center;
    flex-wrap: wrap;
    gap: 10px;
  }

  .btn {
    margin-right: 0;
  }
}

@media (max-width: 480px) {
  h1,
  h3 {
    font-size: 2.5rem;
  }

  p {
    font-size: 1rem;
  }

  .community-card {
    gap: 8px;
  }
}
</style>


